export default __webpack_public_path__ + "static/media/Increase_site_font.cea05880.svg";